export const chapters = [
  {
    id: 1,
    part: 1,
    englishTitle: "The Hidden Leaf",
    kanjiTitle: "tbd",
    romanizedTitle: "tbd",
    available: false,
    content: `Content for Uzumaki Naruto...`,
 }
];